/**
 * Tool processor for the Now Assist Skill Plugin
 *
 * This file is a re-export orchestrator for backward compatibility.
 * The actual implementation has been split into focused modules:
 *
 * - tool-utils.ts: Shared utilities (RawCodeShape, normalizeInputFieldName, etc.)
 * - tool-parser.ts: Parsing, validation, and orchestration (processTools, extractToolDefinitions)
 * - tool-transform.ts: XML→Fluent reverse transform (generateTools)
 * - tool-shape-builder.ts: ToolDefinition[]→ArrowFunctionShape (buildToolsArrowFunctionShape)
 * - tool-types.ts: Type definitions (ToolDefinition, ToolValidationResult)
 * - tools/inline-script-tool.ts: processInlineScriptTool
 * - tools/script-tool.ts: processScriptTool
 * - tools/subflow-tool.ts: processSubflowTool
 * - tools/web-search-tool.ts: processWebSearchTool
 * - tools/flow-action-tool.ts: processFlowActionTool
 * - tools/skill-tool.ts: processSkillTool
 * - tools/decision-tool.ts: processDecisionTool, createDecisionEdges
 */

// Re-export types
export type { ToolDefinition, ToolValidationResult } from './tool-types'

// Re-export shared utilities
export { RawCodeShape, normalizeInputFieldName, inputChainToTemplate } from './tool-utils'

// Re-export individual tool processors
export { processInlineScriptTool } from './tools/inline-script-tool'
export { processScriptTool } from './tools/script-tool'
export { processSubflowTool } from './tools/subflow-tool'
export { processWebSearchTool } from './tools/web-search-tool'
export { processFlowActionTool } from './tools/flow-action-tool'
export { processSkillTool } from './tools/skill-tool'
export { processDecisionTool, createDecisionEdges } from './tools/decision-tool'

// Re-export parser/orchestrator
export { processTools } from './tool-parser'

// Re-export transform (XML→Fluent)
export { generateTools } from './tool-transform'

// Re-export shape builder (ToolDefinition[]→ArrowFunctionShape)
export { buildToolsArrowFunctionShape } from './tool-shape-builder'
